{{each OnlyOneData item i}}
    <div class="item clearfix mb10">
        <a href="./home.html?userid={{item.UserID}}"><img class="fl" src="{{item.SmallDataUrl}}"></a>
        <div style="display:inline-block" class="fl">
            <p>{{item.NickName}}</p>
            {{if item.ShowTip === "未接通"}}
            <h4 class="call-my-tips" style="color: #FF5379">{{item.ShowTip}}</h4>
            {{else}}
            <h4 class="call-my-tips">{{item.ShowTip}}</h4>
            {{/if}}
            <h4 class="call-my-tips">{{item.ShowTime}}</h4>
        </div>
        {{if item.CallStatus == -1 || item.CallStatus == 3 || item.CallStatus == 9 }}
        <!--热聊中-->
            <a class="op-btn disabled-btn fr">不可通话</a>
        {{else if item.CallStatus == 2 || item.CallStatus == 5}}
        <!--接通电话-->
            <a class="op-btn linear-btn fr detailCallBtn" data-id="{{item.UserID}}">通话</a>
        {{else if item.CallStatus == 1 || item.CallStatus == 4 || item.CallStatus == 6 || item.CallStatus == 7 || item.CallStatus == 8}}
        <!--魔术唤醒-->
            <a class="op-btn migic-btn fr detailMagicBtn" data-id="{{item.UserID}}">魔术唤醒</a>
        {{/if}}
        <!----  
        // 第一版判断方式 2020/02/25
        {{if item.CallStatus == -1 || item.CallStatus == 3}}
            未绑定手机||热聊中
            <a class="op-btn disabled-btn fr">不可通话</a>
        {{else if item.CallStatus != -1 && (item.CallStatus == 2||item.CallStatus == 5)}}
            绑定手机&&(放电中||空闲中)
            <a class="op-btn linear-btn fr detailCallBtn" data-id="{{item.UserID}}">通话</a>
        {{else if item.CallStatus != -1 && (item.CallStatus == 6||item.CallStatus == 4||item.CallStatus == 1||item.CallStatus == 7)}}
            绑定手机&&(非通话对象||非通话时段||免打扰||直播中)
            <a class="op-btn migic-btn fr detailMagicBtn" data-id="{{item.UserID}}">魔术唤醒</a>
        {{/if}}
        --->
    </div>
{{/each}}